import { Link, type LinkProps } from '@mui/material'
import React, { forwardRef } from 'react'

export const MUIExternalLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, ...rest }, ref) => {
    return (
      <Link
        ref={ref}
        rel="noopener noreferrer nofollow"
        target="_blank"
        {...rest}
      >
        {children}
      </Link>
    )
  }
)
